import Crud from '../views/Empresa/Crud'
import Entity from '../views/Empresa/Add'

let routes = {
    path: '/empresas',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/empresas/add',
            name: 'NewEmpresa',
            component: Entity,
            meta: {
                pageTitle: 'Lista de Empresas',
                breadcrumb: [
                    {
                        text: 'Empresas',
                        active: false,
                        to: '/empresas',
                    },
                    {
                        text: 'criar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/empresas/edit/:id?',
            name: 'EditEmpresa',
            component: Entity,
            meta: {
                pageTitle: 'Empresas',
                breadcrumb: [
                    {
                        text: 'Empresas',
                        active: false,
                        to: '/empresas',
                    },
                    {
                        text: 'editar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/empresas',
            name: 'list-empresas',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Empresas',
                breadcrumb: [
                    {
                        text: 'Empresas',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
